(function () {
  function initFomoNotifier(root) {
    var containers = (root || document).querySelectorAll('.product-fomo-notifier');
    containers.forEach(function (container) {
      if (container.dataset.fomoNotifierReady === 'true') return;

      var target = container.querySelector('[data-fomo-notifier-text]');
      var messages = container.querySelectorAll('[data-fomo-notifier-message]');
      if (!target || !messages.length) return;

      var index = Math.floor(Math.random() * messages.length);
      target.textContent = messages[index].textContent;
      container.dataset.fomoNotifierReady = 'true';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initFomoNotifier();
    });
  } else {
    initFomoNotifier();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initFomoNotifier(event.target);
  });
})();
